import Clickable from '@prisjakt/ui-clickable';
import {
  ButtonIcon,
  ButtonSize,
  TonalButton,
} from '@prisjakt/ui/button/variants';
import { IconMagnifier } from '@prisjakt/ui/icon';
import React from 'react';
import * as S from './styles';

type Props = {
  children: React.ReactNode;
  onClick?: (event: React.MouseEvent) => void;
  to?: string;
  containerProps?: {};
};

export const Pill = (props: Props) => {
  const { children, onClick, to, containerProps } = props;

  return (
    <S.StyledPill key={to}>
      <TonalButton
        container={Clickable}
        containerProps={{ to, title: children, ...containerProps }}
        onClick={onClick}
        size={ButtonSize.SMALL}
        fullWidth
      >
        <ButtonIcon>
          <IconMagnifier />
        </ButtonIcon>
        <S.StyledButtonText>{children}</S.StyledButtonText>
      </TonalButton>
    </S.StyledPill>
  );
};
